<div class="step-wrapper" [attr.data-testid]="dataTestIds.POLARIS_PROGRESS_BAR">
  <div
    *ngFor="let step of [].constructor(totalSteps); let i = index"
    class="step"
    [ngClass]="{
      'completed': i < currentStep - 1 || isCompleted,
      'current': i === currentStep - 1 && ! isCompleted,
      'first': i === 0,
      'last': i === totalSteps-1
    }"
  >
    <div class="step-icon">
      <span *ngIf="i < currentStep - 1 || isCompleted" class="checkmark">
        <img [src]="'svg/vector.svg' | assetVersion">
      </span>
    </div>
    <div class="step-bar"></div>
  </div>
</div>
<div class="step-label-container">
  <div class="step-index">{{ (isCompleted ? totalSteps : currentStep) + "/" + totalSteps }}</div>
  <div class="step-label">{{ stepLabels[isCompleted ? stepLabels.length - 1 : currentStep - 1] }}</div>
</div>
